import React from "react";

function GithubIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.90001 0.100008C4.30001 0.600008 0.600009 4.30001 0.100009 8.80001C-0.399991 13.5 2.30001 17.7 6.40001 19.3C6.70001 19.4 7.00001 19.2 7.00001 18.8V17.2C7.00001 17.2 6.60001 17.3 6.10001 17.3C4.70001 17.3 4.10001 16.1 4.00001 15.4C3.90001 15 3.70001 14.7 3.40001 14.4C3.10001 14.3 3.00001 14.3 3.00001 14.2C3.00001 14 3.30001 14 3.40001 14C4.00001 14 4.50001 14.7 4.70001 15C5.20001 15.8 5.80001 16 6.10001 16C6.50001 16 6.80001 15.9 7.00001 15.8C7.10001 15.1 7.40001 14.4 8.00001 14C5.70001 13.5 4.00001 12.2 4.00001 10C4.00001 8.90001 4.50001 7.80001 5.20001 7.00001C5.10001 6.80001 5.00001 6.30001 5.00001 5.60001C5.00001 5.20001 5.00001 4.70001 5.20001 4.30001C5.20001 4.10001 5.40001 4.00001 5.50001 4.00001H5.60001C6.10001 4.10001 7.10001 4.40001 8.00001 5.30001C8.60001 5.10001 9.30001 5.00001 10 5.00001C10.7 5.00001 11.4 5.10001 12 5.30001C12.9 4.40001 14 4.10001 14.5 4.00001H14.6C14.8 4.00001 14.9 4.10001 15 4.30001C15 4.70001 15 5.20001 15 5.60001C15 6.40001 14.9 6.80001 14.8 7.00001C15.5 7.80001 16 8.80001 16 10C16 12.2 14.3 13.5 12 14C12.6 14.5 13 15.4 13 16.3V18.9C13 19.2 13.3 19.5 13.7 19.4C17.4 17.9 20 14.3 20 10.1C20 4.10001 14.9 -0.599993 8.90001 0.100008Z"
        fill="black"
      />
    </svg>
  );
}

export default GithubIcon;
